/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbaording_Permission_TitleInputs */

const en_onbaording_permission_title = /** @type {(inputs: Onbaording_Permission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep Your Focus Flowing`)
};

const ar_onbaording_permission_title = /** @type {(inputs: Onbaording_Permission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حافظ على تدفق تركيزك`)
};

const de_onbaording_permission_title = /** @type {(inputs: Onbaording_Permission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halten Sie Ihren Fokus im Fluss`)
};

const es_onbaording_permission_title = /** @type {(inputs: Onbaording_Permission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantén tu flujo de concentración`)
};

const fr_onbaording_permission_title = /** @type {(inputs: Onbaording_Permission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préservez votre élan de concentration`)
};

const it_onbaording_permission_title = /** @type {(inputs: Onbaording_Permission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantieni la concentrazione fluida`)
};

const ja_onbaording_permission_title = /** @type {(inputs: Onbaording_Permission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中力をキープしよう`)
};

const ko_onbaording_permission_title = /** @type {(inputs: Onbaording_Permission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중의 흐름이 끊어지지 않게`)
};

const pt_br_onbaording_permission_title = /** @type {(inputs: Onbaording_Permission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantenha seu foco fluindo`)
};

const ru_onbaording_permission_title = /** @type {(inputs: Onbaording_Permission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжайте фокусировку`)
};

const th_onbaording_permission_title = /** @type {(inputs: Onbaording_Permission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รักษาการโฟกัสของคุณให้ต่อเนื่อง`)
};

const tr_onbaording_permission_title = /** @type {(inputs: Onbaording_Permission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaklanmanı Sürdür`)
};

const zh_cn_onbaording_permission_title = /** @type {(inputs: Onbaording_Permission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保持你的专注节奏`)
};

const zh_tw_onbaording_permission_title = /** @type {(inputs: Onbaording_Permission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保持你的專注節奏`)
};

/**
* | output |
* | --- |
* | "Keep Your Focus Flowing" |
*
* @param {Onbaording_Permission_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onbaording_permission_title = /** @type {((inputs?: Onbaording_Permission_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbaording_Permission_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbaording_permission_title(inputs)
	if (locale === "ar") return ar_onbaording_permission_title(inputs)
	if (locale === "de") return de_onbaording_permission_title(inputs)
	if (locale === "es") return es_onbaording_permission_title(inputs)
	if (locale === "fr") return fr_onbaording_permission_title(inputs)
	if (locale === "it") return it_onbaording_permission_title(inputs)
	if (locale === "ja") return ja_onbaording_permission_title(inputs)
	if (locale === "ko") return ko_onbaording_permission_title(inputs)
	if (locale === "pt_br") return pt_br_onbaording_permission_title(inputs)
	if (locale === "ru") return ru_onbaording_permission_title(inputs)
	if (locale === "th") return th_onbaording_permission_title(inputs)
	if (locale === "tr") return tr_onbaording_permission_title(inputs)
	if (locale === "zh_cn") return zh_cn_onbaording_permission_title(inputs)
	return zh_tw_onbaording_permission_title(inputs)
});